@if(isPageInitialized) {
  <div class="dashboard-wrapper">
    <div class="dashboard-top-section d-flex align-items-center justify-content-between">
      <h1>{{ 'maintenanceDashboard.maintenanceTitle' | transloco }}</h1>

      <div class="search-menu-lists d-flex">
        <div class="filters d-flex align-items-center gap-2">
          <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

          <div class="common-drop-down date-height">
            <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
              [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
              (filterChanged)="onDateFilterChange($event)">
            </app-date-filter>
          </div>

          <button class="btn-create-maintenance" (click)="onCreateMaintenanceClick()">
            <span>{{ 'maintenanceDashboard.createMaintenance' | transloco }}</span>
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard-widgets">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-overdue-maintenance [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-overdue-maintenance>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-upcoming-maintenance [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-upcoming-maintenance>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-unplanned-repairs [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-unplanned-repairs>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-maintenance-cost-ytd [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-maintenance-cost-ytd>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="dashboard-graphs">
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <app-preventive-vs-reactive></app-preventive-vs-reactive>
          </div>
          <div class="col-xl-6 col-lg-12">
            <app-assets-in-maintenance></app-assets-in-maintenance>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <app-asset-downtime-trend></app-asset-downtime-trend>
          </div>
          <div class="col-xl-6 col-lg-12">
            <app-top-assets-cost></app-top-assets-cost>
          </div>
        </div>
      </div>

      <div class="dashboard-sidebar">
        <div class="next-maintenance-card">
          <div class="card-header">
            <h3>{{ 'maintenanceDashboard.nextMaintenance' | transloco }}</h3>
            @if(nextMaintenanceItems.length) {
              <button class="btn-see-more" (click)="onSeeMore()">{{ 'maintenanceDashboard.seeMore' | transloco }}</button>
            }
          </div>

          @if(isLoading && page === 1) {
            <div class="loading-state">
              <div class="spinner-border"></div>
            </div>
          } @else {
            @if(nextMaintenanceItems.length > 0) {
              <div
                class="maintenance-list"
                infiniteScroll
                [scrollWindow]="false"
                (scrolled)="onNextMaintenanceScroll()"
                [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="300">
                @for(item of nextMaintenanceItems; track item.workOrderId) {
                  <div class="maintenance-item">
                    <div class="item-info">
                      <div class="item-text">
                        <h4>{{ item.assetName }}</h4>
                        <p class="assigned-to">{{ 'maintenanceDashboard.assignedTo' | transloco: { name: item.technician } }}</p>
                      </div>
                      <span class="badge badge-warning">{{ formatDueDate(item.daysRemaining) }}</span>
                    </div>
                    <span class="service-type-tag">{{ item.maintenanceReason }}</span>
                  </div>
                }

                @if(page > 1 && isLoading) {
                  <div class="d-flex justify-content-center py-2">
                    <span class="spinner-border spinner-border-sm"></span>
                  </div>
                }
              </div>
            } @else {
              <div class="empty-state">
                <app-empty-state></app-empty-state>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
}